// @ts-nocheck
import React, {useEffect, useState} from 'react';
import {
    Button,
    Col,
    Flex,
    Form,
    Input,
    Select,
    Upload,
    message,
    Checkbox,
    Row,
    Card,
    Divider,
    StepsProps,
    Popover
} from "antd";
// @ts-nocheck
import Header from "../../components/header/Header";
import {useForm} from "antd/es/form/Form";
import {useLocation, useNavigate} from "react-router-dom";
import style from "./AInsertStepThree.module.scss"
import {PlusOutlined} from '@ant-design/icons';
import {connect} from "react-redux";
import {registerProduct} from "../../actions/AdInsert.action";
import {withRouter} from "../../../../utils/services/with-router";
import {AdInsertStepThreeProps} from "../../models";
import {uploadImage} from "../../../../shared";
import {StyledSteps} from "../AdInsertSteps.styled";
import PriceCard from "../../components/priceCard/PriceCard";
import {GuaranteeCard} from "../../components";
import PropertiesCard from "../../components/propertiesCard/PropertiesCard";
import ConditionsCard from "../../components/conditionsCard/ConditionsCard";
import {logDOM} from "@testing-library/react";
import BackGroundLogo from "../../components/adBackGroundLogo/BackGroundLogo";

const AdInsertStepThree = ({registerProduct, uploadImage}: AdInsertStepThreeProps) => {
    const [fileList, setFileList] = useState([]);
    const [base64Images, setBase64Images] = useState([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [form] = useForm();
    const location = useLocation();
    const navigate = useNavigate();
    const [allUploadedImages, setAllUploadedImages] = useState([]);
    const domain = "https://peydaapp.ir";

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const handleUploadChange = async ({fileList: newFileList}) => {
        setFileList(newFileList);

    };
    const onBackToStepTwo = async () => {
        setLoading(true)
        const updatedFileList = await Promise.all(fileList.map(async (file) => {
            if (file.isUploaded) return file;

            const base64 = await convertToBase64(file.originFileObj);
            const normalUrl = await _uploadImage({data: base64, isThumbnail: false});

            return {
                ...file,
                url: normalUrl,
                isThumbnail: false,
                isUploaded: true,
            };
        }));
        setLoading(false)
        navigate('/ad-insert-step-two', {
            state: {
                ...location.state,
                uploadedImages: updatedFileList,
            }
        });
    };

    const test = async (fileList) => {
        const trackingCodes = [];
        const displayFiles = [];

        for (let i = 0; i < fileList?.length; i++) {
            const file = fileList[i]?.originFileObj;
            const base64 = await convertToBase64(file);

            try {
                if (i === 0) {
                    const thumbRes = await _uploadImage({data: base64, isThumbnail: true});
                    const normalRes = await _uploadImage({data: base64, isThumbnail: false});

                    trackingCodes.push({url: thumbRes, isThumbnail: true});
                    trackingCodes.push({url: normalRes, isThumbnail: false});

                    // Add normal image to preview (thumbnail doesn't need to be displayed twice)
                    displayFiles.push({
                        uid: `-${i}`,
                        name: 'image.png',
                        status: 'done',
                        url: `${domain}/${normalRes}`,
                    });
                } else {
                    const res = await _uploadImage({data: base64, isThumbnail: false});
                    trackingCodes.push({url: res, isThumbnail: false});

                    displayFiles.push({
                        uid: `-${i}`,
                        name: 'image.png',
                        status: 'done',
                        url: `${domain}/${res}`,
                    });
                }
            } catch (e) {
                console.error(e);
            }
        }

        // Set previewable file list
        setFileList(displayFiles);

        return trackingCodes;
    };
    const _uploadImage = (value: any) => {
        return uploadImage(value)
            .then((data: any) => {
                if (data.payload != undefined) {
                    return data.payload.data;
                }
            })
            .catch((e: any) => {
            });
    }
    const onFinish = async () => {
        setLoading(true);

        const uploadedNewImages = await Promise.all(fileList.map(async (file) => {
            if (file.isUploaded) return file;

            const base64 = await convertToBase64(file.originFileObj);
            const normalUrl = await _uploadImage({data: base64, isThumbnail: false});

            return normalUrl


        }));

        const finalImages = [...(allUploadedImages || []), ...uploadedNewImages];

        // remove duplicates based on URL
        const uniqueImages = Array.from(new Map(
            finalImages.map(img => [img.url, img])
        ).values());

        const productImages = uniqueImages.map(({url}) => ({url}));

        setLoading(false);

        let model = {
            ...location.state.stepTwoForm,
            productImages: uniqueImages,
        }
        console.log(model)
        registerProduct(model)
            .then((data: any) => {
                setLoading(false)
                if (data.payload != undefined) {
                    navigate("/user-products")
                    message.success('آگهی شما با موفقیت ثبت شدو پس از تایید در لیست آگهی های عمومی نمایش داده خواهد شد. ')
                    
                }
            })
            .catch((e: any) => {
            });
    }
    useEffect(() => {
        console.log(location.state)
    }, [location]);
    const customDot: StepsProps['progressDot'] = (dot, {status, index}) => (
        <Popover

        >
            {dot}
        </Popover>
    );
    useEffect(() => {
        if (location.state?.uploadedImages) {
            const uploadedImages = location.state.uploadedImages;

            setFileList(uploadedImages); // Show all directly now
            setAllUploadedImages(uploadedImages);
        }
    }, [location]);

    return (
        <Flex vertical gap={"small"}>
            <Header step={3}/>
            <BackGroundLogo step={3}/>

            <Flex vertical gap={"large"}>
                <Card>
                <Flex justify="center">
                    <div style={{ fontSize: "13px", color: "#555" }}>
                         📸 لطفاً تصاویر <b>واضح و واقعی</b> از کالا بارگذاری کنید.<br />
                        <span style={{ color: "#666" }}>اولین عکس به‌عنوان تصویر اصلی آگهی نمایش داده می‌شود.</span><br />
                        برای جلب اعتماد کاربران، سعی کنید عکس‌ها را در <b>نور مناسب</b> و از <b>زوایای مختلف</b> بگیرید.
                    </div>
                </Flex>
                </Card>


                    {/* Image Upload */}

                    <Upload
                        listType="picture-card"
                        fileList={fileList}
                        onChange={handleUploadChange}
                        beforeUpload={() => false}
                        showUploadList={{
                            showPreviewIcon: false
                        }}
                    >
                        {fileList?.length < 6 && (
                            <div>
                                <PlusOutlined/>
                                <div style={{marginTop: 8}}>بارگذاری تصاویر</div>
                            </div>
                        )}
                    </Upload>

                </Flex>

                <Form form={form} onFinish={onFinish}>
                    <Flex vertical>

                        <Flex gap={"small"} className={style.customBtns}>
                            <Button loading={loading} htmlType={"submit"} size={"large"} type={"primary"}
                                    block> ثبت آگهی</Button>
                            <Button loading={loading} onClick={onBackToStepTwo} size={"large"} block>مرحله قبل</Button>
                        </Flex>
                    </Flex>
                </Form>
        </Flex>
    );

};


export default connect(null, {registerProduct, uploadImage})(withRouter(AdInsertStepThree));
